import { render, staticRenderFns } from "./PolinizationTable.vue?vue&type=template&id=32345105&scoped=true&lang=html&"
import script from "./PolinizationTable.vue?vue&type=script&lang=js&"
export * from "./PolinizationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32345105",
  null
  
)

export default component.exports